import { __assign } from "tslib";
import { connect } from 'react-redux';
import { compose } from 'redux';
import Columns from '../../../components/handoff/layout/Columns';
import onlyIf from '../../../hocs/onlyIf';
import { getColumnConfig, getIsColumnOverlayOn, } from '../../../selectors/layoutOverlay';
function mapStateToProps(state) {
    return __assign(__assign({}, getColumnConfig(state)), { isOverlayOn: getIsColumnOverlayOn(state) });
}
var isOverlayOn = function (props) { return props.isOverlayOn; };
export default compose(connect(mapStateToProps), onlyIf(isOverlayOn))(Columns);
